type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'PaymentGateway'
const nameSource = 'financial/paymentGateways'
const namePageTitle = 'PaymentGateways'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'paymentGateways',
  to: '/financial/paymentGateways',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/paymentGateways/create',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/paymentGateways/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/paymentGateways/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
